import PropTypes from 'prop-types';

function CountryOfOriginIcon({ width }) {
    return (
        <svg width={width} height={width} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6071_2717)">
                <path
                    d="M18.3788 2.96058C15.143 0.282415 9.42094 0.978041 6.45822 3.89098C3.4955 6.80392 3.09467 11.2559 4.61959 14.9254C5.46774 16.9717 11.1056 23.1367 12.921 25.0931C13.1882 25.3801 13.7024 25.3395 13.9028 25.012C15.3173 22.6961 19.8573 15.1688 20.4498 13.0211C21.4083 9.54875 21.3444 5.41266 18.3788 2.96348V2.96058ZM15.7065 13.2588C14.5127 14.2877 12.7961 14.6355 11.2683 14.25C9.78111 13.8732 8.46532 12.7979 7.89601 11.3748C6.55698 8.02127 10.1239 4.52284 13.5223 5.28513C17.0049 6.06771 18.5502 10.8038 15.8053 13.1689L15.7065 13.2588Z"
                    fill="#DE8255"
                    stroke="#2D2D2D"
                    strokeWidth="0.75"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_6071_2717">
                    <rect width="25" height="25" fill="white" transform="translate(0 0.785217)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default CountryOfOriginIcon;

CountryOfOriginIcon.propTypes = {
    width: PropTypes.number,
};

CountryOfOriginIcon.defaultProps = {
    width: 30,
};
